import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { AgGridAngular } from 'ag-grid-angular';
import {
  ColDef,
  // ColumnApi,
  GridApi,
  GridReadyEvent,
  themeQuartz
} from 'ag-grid-community';

import { DatePipe } from '@angular/common';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { base64StringToBlob } from 'blob-util';
import { saveAs } from 'file-saver';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { catchError, throwError } from 'rxjs';
import { UserDetailsService } from 'src/app/service/user-details.service';
import { config } from 'src/app/valueObject/config';
import { AuditServiceService } from '../audit-service.service';
@Component({
    selector: 'app-internal-audit-follow-on-exchange-action',
    templateUrl: './internal-audit-follow-on-exchange-action.component.html',
    styleUrls: ['./internal-audit-follow-on-exchange-action.component.css'],
    standalone: false
})
export class InternalAuditFollowOnExchangeActionComponent implements OnInit {
  theme = themeQuartz;
  config: any = config;
  message: any;

  internalAuditFOcolumnDefs: ColDef[] = [];
  internalAuditFORowData: any[] = [];
  internalAuditGridApi: GridApi;
  // internalAuditColApi: ColumnApi;
  internalAuditData: any = {};

  user: any = {};
  access: any = {};
  memId: any;
  entityCode: any;
  entityType: any;
  userId: any;
  loginId: any;
  file: File;
  fileError: any;
  requestId: any;
  enableSignPdfDnld: boolean = false;
  approveRejectForm: FormGroup;
  isCheckerAllowed: boolean = true;

  enableAuditorFoSignPdfDnld: boolean = false;
  enableMemberFoSignPdfDnld: boolean = false;

  @ViewChild(AgGridAngular) agGrid!: AgGridAngular;
  @ViewChild('internalAuditAgGrid') systemAuditAngularGrid: AgGridAngular;

  onGridReady(params: GridReadyEvent) {

    this.internalAuditGridApi = params.api;
    // this.internalAuditColApi = params.columnApi;
  }

  constructor(
    private fb: FormBuilder,
    private titleService: Title,
    private toastr: ToastrService,
    private userDetailsService: UserDetailsService,
    private auditService: AuditServiceService,
    private datePipe: DatePipe,
    private cdref: ChangeDetectorRef,
    private router: Router,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private http: HttpClient,
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle('Internal Audit Follow On Report Submission');
    this.requestId = this.route.snapshot.params['auditRequestId'];
    this.user = this.userDetailsService.getUserDetails() || {};
    this.entityType = this.user.entityType;
    this.entityCode = this.user.entityCode;
    this.userId = this.user.userId;
    this.loginId = this.user.loginId;
    this.memId = (<number>this.user.entityCode ) + "";
    this.getFollowOnReportData();
    this.approveRejectForm = this.fb.group({
      auditComment: [''],
      auditRequestId: [''],
      stageName: [''],
      commentByMaker: [{ value: '', disabled: true }],
      requestApprovedbyMaker: [{ value: '', disabled: true }],
      commentByChecker: [{ value: '', disabled: true }],
      requestApprovedByChecker: [{ value: '', disabled: true }],
      requestApprovedDateByMaker: [{ value: '', disabled: true }],
      requestApprovedDateByChecker: [{ value: '', disabled: true }]
    })

  }
  get f() {
    return this.approveRejectForm.controls;
  }
  public internalAuditDefcolumnDefs: ColDef = {
    resizable: false,
    suppressSizeToFit: true,
    minWidth: 100,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    cellStyle: { borderRight: '1px solid #3B2E7E' }, 
    headerStyle: {
      backgroundColor: '#3B2E7E', 
      color: 'white',          
      fontWeight: 'bold'
    },

    cellClass: params => {
      return params.data.isMainHeader ? 'bold-text' : '';
    }
  }

  getFollowOnReportData() {
    this.auditService.getInternalAuditFollowOnReportbyId(this.requestId).pipe(
      catchError((error: any) => {
        this.toastr.error(this.config.failureResponse.SOMETHING_WENT_WRONG);
        if (error.status != 200) {
          this.spinner.hide();
          return throwError(error.error);
        }
      })
    ).subscribe(
      (response: any) => {
        if (response.statusCode == 200) {
          this.internalAuditFORowData = JSON.parse(response.data.systemAuditFOData);
          this.internalAuditData = response.data;
          this.getColumnDetails();
          if (this.internalAuditData.currentStage >= 3) {
            this.enableAuditorFoSignPdfDnld = true
          }
          if (this.internalAuditData.currentStage >= 4) {
            this.enableMemberFoSignPdfDnld = true
          }
          let systemAuditTempcolumnDefs = this.internalAuditFOcolumnDefs;
          this.f.commentByMaker.setValue(response.data.commentByMaker);
          this.f.commentByChecker.setValue(response.data.commentByChecker);
          this.f.requestApprovedDateByMaker.setValue(this.datePipe.transform(response.data.requestApprovedDateByMaker, 'yyyy-MMM-dd'));
          this.f.requestApprovedDateByChecker.setValue(this.datePipe.transform(response.data.requestApprovedDateByChecker, 'yyyy-MMM-dd'));
          for (let i = 0; i < systemAuditTempcolumnDefs.length; i++) {
            this.internalAuditFOcolumnDefs[i].editable = false;
            if (systemAuditTempcolumnDefs[i].cellDataType === 'date') {
              for (let j = 0; j < this.internalAuditFORowData.length; j++) {
                if (this.internalAuditFORowData[j][this.internalAuditFOcolumnDefs[i].field] !== null) {
                  this.internalAuditFORowData[j][this.internalAuditFOcolumnDefs[i].field] = new Date(this.internalAuditFORowData[j][this.internalAuditFOcolumnDefs[i].field]);
                }
              }
            }
            if (this.internalAuditData.currentStage > 3) {
              this.enableSignPdfDnld = true;
            }
            if (this.internalAuditData.requestApprovedbyMaker == this.userId) {
              this.isCheckerAllowed = false;
            }
          }
        } else {
          this.toastr.error(response.message);
        }
      })
  }
  downloadPdf() {
    let jsonData = this.internalAuditFORowData;
    let auditRequestId = this.internalAuditData['auditRequestId'];
    let data = jsonData[0];
    let column: string[] = Object.keys(data);
    let cols: any = [];
    var detailKey = 2;
    for (var i = 0; i < column.length; i++) {
      if (column[i] === 'details') {
        detailKey = i;
      }
      if (column[i] == 'isMainHeader') {
        continue;
      }
      else {
        cols.push(column[i]);
      }
    }

    var rows = [];

    for (var i = 0; i < jsonData.length; i++) {
      let tmpData = jsonData[i];
      var temp = [];
      for (var j = 0; j < cols.length; j++) {

        temp.push(tmpData[cols[j]]);
      }
      rows.push(temp);
    }

    const doc = new jsPDF('p', 'mm', [1200, 1200]);
    autoTable(doc, { html: '#my-Table', columnStyles: { details: { cellWidth: 1000 } } });
    autoTable(doc, {
      head: [cols]
      , body: rows,
    });
    doc.save('InternalAuditFollowOn_' + auditRequestId + '_.pdf');
  }

  downloadSignedReport(entityType: any) {

    // this.spinner.show();
    let fileName = this.internalAuditData.auditRequestId + "_FollowOn.pdf";
    this.auditService.getFileInternalSignedReportDownload(this.internalAuditData.memId , this.internalAuditData.auditRequestId, "FollowOn", entityType).pipe(
      catchError((error: any) => {
        this.spinner.hide();
        this.toastr.error(this.config.failureResponse.SOMETHING_WENT_WRONG);
        if (error.status != 200) {
          return throwError(error.error);
        }
      })
    ).subscribe((response: any) => {
      // this.spinner.hide();
      if (response.statusCode == 200) {
        let dnldFile = response.data;
        let contentType = 'application/pdf';
        let blob = base64StringToBlob(dnldFile, contentType);
        saveAs(blob, fileName, {
          autoBOM: true
        });
        this.toastr.success("File downloaded Succesfully");
      } else {
        this.toastr.error("File download Failed");
      }
    })
  }

  submitApproverRequest(decisionBy: string, decisionFlag: string) {

    this.spinner.show();
    if (decisionBy === 'Maker') {
      this.f.stageName.setValue((decisionFlag === 'Y') ? 'EXCHANGEFO_MAKER_APPROVE_FORM' : 'EXCHANGEFO_MAKER_REJECT_FORM');
      this.f.commentByMaker.setValue(this.f.auditComment.value);

    }
    else if (decisionBy === 'Checker') {
      this.f.stageName.setValue((decisionFlag === 'Y') ? 'EXCHANGEFO_CHECKER_APPROVE_FORM' : 'EXCHANGEFO_CHECKER_REJECT_FORM');
      this.f.commentByChecker.setValue(this.f.auditComment.value);

    }


    this.internalAuditData.stageName = this.f.stageName.value;
    this.internalAuditData.commentByMaker = this.f.commentByMaker.value;
    this.internalAuditData.commentByChecker = this.f.commentByChecker.value;
    this.internalAuditData.userId = this.userId

    this.auditService.updateInternalAuditFollowOn(this.internalAuditData).pipe(
      catchError((error: any) => {
        this.spinner.hide();
        this.toastr.error(this.config.failureResponse.SOMETHING_WENT_WRONG);
        if (error.status != 200) {
          return throwError(error.error);
        }
      })
    ).subscribe((response: any) => {
      this.spinner.hide();
      if (response.statusCode == 200) {
        this.router.navigate(['/complianceAdmin/internalAudit/adminMIS']);
        this.toastr.success(response.message);
        this.spinner.hide();
      }
      else if (response.statusCode == 404) {
        this.spinner.hide();
        this.toastr.success("DATA NOT FOUND");
      }
    })

  }


  getColumnDetails() {
    this.internalAuditFOcolumnDefs = [
      {
        field: 'preliminaryAuditdate',
        headerName: 'Preliminary Audit Date',
        cellDataType: "text",
        editable: false,
        sortable: true,
        wrapText: true,
        autoHeight: true,


      },
      {
        field: 'preliminaryObservationNumber',
        headerName: 'Preliminary Observation Number',
        cellDataType: "text",
        editable: false,
        sortable: true,
        wrapText: true,
        autoHeight: true,
        pinned: "left",
        width: 180,
        maxWidth: 200,
      },
      {
        field: 'details',
        headerName: 'TOR Clause Details',
        cellDataType: "text",
        editable: false,
        sortable: true,
        wrapText: true,
        autoHeight: true,
        cellEditorPopup: true,
        initialWidth: 800,
        maxWidth: 900,
        minWidth: 600,
        cellStyle: {
          color: '#3B2E7E',
        },
        cellEditorParams: {
          maxLength: 100,
          rows: 5,
          cols: 100
        }
      },
      {
        field: 'preliminaryStatus',
        headerName: 'Preliminary Status',
        cellDataType: "text",
        editable: true,
        sortable: true,
        wrapText: true,
        autoHeight: true
      },
      {
        field: 'preliminaryCorrectiveAction',
        headerName: 'Preliminary Corrective Action',
        cellDataType: "text",
        editable: true,
        sortable: true,
        wrapText: true,
        autoHeight: true
      },
      {
        field: 'currentFinding',
        headerName: 'Current Finding',
        cellDataType: "text",
        editable: false,
        sortable: true,
        wrapText: true,
        autoHeight: true
      },
      {
        field: 'currentStatus',
        headerName: 'Current Status',
        cellDataType: "list",
        editable: true,
        sortable: true,
        wrapText: true,
        autoHeight: true,
        cellEditor: "agSelectCellEditor",
        cellEditorParams: {
          values: [
            "Compliant",
            "Non Compliant",
            "Work in progress"
          ]

        }
      },
      {
        field: 'revisedCorrectiveAction',
        headerName: 'Revised Corrective Action',
        cellDataType: "text",
        editable: true,
        sortable: true,
        wrapText: true,
        autoHeight: true
      },
      {
        field: 'deadlineForRevisedCorrectiveAction',
        headerName: 'Deadline For Revised Corrective Action',
        cellDataType: "date",
        editable: true,
        sortable: true,
        wrapText: true,
        autoHeight: true
      },
      {
        field: 'verifiedBy',
        headerName: 'Verified By',
        cellDataType: "text",
        editable: false,
        sortable: true,
        wrapText: true,
        autoHeight: true,
      },
      {
        field: 'closingDate',
        headerName: 'Closing Date',
        cellDataType: "date",
        editable: false,
        sortable: true,
        wrapText: true,
        autoHeight: true,
      },
      {
        field: 'managementComment',
        headerName: 'management Comment',
        cellDataType: "text",
        editable: false,
        sortable: true,
        wrapText: true,
        autoHeight: true,
      }
    ];
  }
}